import { ModuleLayout } from "layouts";
import ChatPage from "./ChatPage";

function Chat() {
  return (
    <ModuleLayout title="Support Chat">
      <ChatPage />
    </ModuleLayout>
  );
}

export default Chat;
